'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from 'react';
import { AnimatedBackground } from './animated-background';
import { scrollTabIntoView } from './helpers';
import styles from './tabs.module.css';
export const RadioTab = ({ 'data-testid': testId, icon, id, index, isActive, label, name, onChange, setActive, value })=>{
    const onChangeHandler = useCallback((e)=>{
        onChange?.(e);
        if (e.currentTarget.checked) {
            setActive(index);
            scrollTabIntoView(e.currentTarget);
        }
    }, [
        index,
        onChange,
        setActive
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("input", {
                "aria-controls": `${id}-region-${index}`,
                checked: isActive,
                id: `${id}-radio-${index}`,
                name: name,
                onChange: onChangeHandler,
                type: "radio",
                value: value,
                className: "visually-hidden"
            }),
            /*#__PURE__*/ _jsxs("label", {
                className: styles.tab,
                "data-testid": testId,
                htmlFor: `${id}-radio-${index}`,
                children: [
                    isActive && /*#__PURE__*/ _jsx(AnimatedBackground, {
                        id: id
                    }),
                    /*#__PURE__*/ _jsxs("span", {
                        style: {
                            viewTransitionName: `${id}-radio-${index}`
                        },
                        children: [
                            icon,
                            label
                        ]
                    })
                ]
            })
        ]
    });
};

//# sourceMappingURL=radio-tab.js.map